import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const defaultMeta = {
    title: 'Cospin – Accelerating Digital Transformation',
    description: 'GCC setup, product engineering, and infra/security—done right. Cospin helps enterprises achieve speed, clarity, and impact in their digital transformation journey.',
    type: 'website',
    image: '/og-image.jpg',
    siteName: 'Cospin',
    twitterHandle: '@cospin',
};

const SEO = ({
    title,
    description,
    type = 'website',
    image,
    article = false,
    publishedTime,
    modifiedTime,
    author,
    section,
    structuredData
}) => {
    const location = useLocation();
    const currentUrl = `https://www.cospin.in${location.pathname}`;

    const metaTitle = title ? `${title} | ${defaultMeta.siteName}` : defaultMeta.title;
    const metaDescription = description || defaultMeta.description;
    const metaImage = `https://www.cospin.in${image || defaultMeta.image}`;

    return (
        <Helmet prioritizeSeoTags>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />

            {/* Open Graph */}
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content={defaultMeta.siteName} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={defaultMeta.twitterHandle} />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />

            {/* Canonical */}
            <link rel="canonical" href={currentUrl} />

            {article && publishedTime && (
                <meta property="article:published_time" content={publishedTime} />
            )}
            {article && modifiedTime && (
                <meta property="article:modified_time" content={modifiedTime} />
            )}
            {article && author && (
                <meta property="article:author" content={author} />
            )}
            {article && section && (
                <meta property="article:section" content={section} />
            )}

            {structuredData && (
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            )}
        </Helmet>
    );
};

export default SEO;
